import {FilterLinkIconDefaultBox} from "./filter-link-icon.default.box";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {FilterLinkIconCasino777Box} from "./filter-link-icon.casino777.box";
import {FilterLinkIconSIBox} from "./filter-link-icon.si.box";
import {FilterLinkIconMrGreenBox} from "./filter-link-icon.mrgreen.box";

export const FilterLinkIconBox = styledByTheme(FilterLinkIconDefaultBox)
    .forCasino777(FilterLinkIconCasino777Box)
    .forSI(FilterLinkIconSIBox)
    .forSICis(FilterLinkIconSIBox)
    .forMrGreen(FilterLinkIconMrGreenBox)
    .apply();